import { useState, useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addWarehouse, updateWarehouse } from 'helpers/backend_helper';
import { Common } from 'helpers/common';

export const useWarehouseModal = (onSave: (result: any) => void, initialData?: any) => {
    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [warehouseData, setWarehouseData] = useState<any>(initialData);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();

    useEffect(() => {
        if (initialData) {
            setWarehouseData(initialData);
            setIsEdit(!!initialData.id);
        }
    }, [initialData]);

    const toggle = useCallback(() => {
        setShow(!show);
        if (show) {
            setWarehouseData(null);
        }
    }, [show]);

    const handleEditDataClick = (ele: any) => {
        setWarehouseData({ ...ele });
        setIsEdit(true);
        setShow(true);
    };

    const handleAddWarehouse = () => {
        setWarehouseData({});
        toggle();
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: warehouseData?.name || "",
            location: warehouseData?.location || ""
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please enter warehouse name"),
            location: Yup.string().required("Please enter location")
        }),
        onSubmit: async (values: any) => {
            setIsSaving(true);
            try {
                let result;
                if (isEdit) {
                    result = await updateWarehouse({ ...values, id: warehouseData.id });
                    commonHelper.showSuccessMessage("Warehouse updated successfully");
                } else {
                    result = await addWarehouse(values);
                    commonHelper.showSuccessMessage("Warehouse added successfully");
                }
                
                if (result) {
                    onSave(result);
                }
            } catch (error) {
                console.error('Error saving warehouse:', error);
                commonHelper.showErrorMessage(isEdit ? "Failed to update warehouse" : "Failed to add warehouse");
            } finally {
                setIsSaving(false);
            }
        }
    });

    return {
        show,
        isEdit,
        warehouseData,
        toggle,
        handleEditDataClick,
        handleAddWarehouse,
        validation,
        isSaving
    };
};